export default __webpack_public_path__ + "static/invalid-key-character-17f0e37c9f4fc2f10144f9d9d933c942.svg";